export function roundedToFixed(num, decimalPlaces = 0) {
    return num.toLocaleString('en', {
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces,
        useGrouping: false
    });
}